import angular from 'angular';
import _ from 'lodash';

(function() {
  'use strict';

  angular.module('app.core').component('kissSellerPrincipalAutocompleteFilter', {
    bindings: {
      entitySelected: '='
    },
    controller: SellerPrincipalAutocompleteFilterController,
    templateUrl: require('./seller-principal-autocomplete-filter.html')
  });

  SellerPrincipalAutocompleteFilterController.$inject = ['$q', 'KissSellerSvc', 'PrincipalSvc'];

  function SellerPrincipalAutocompleteFilterController($q, KissSellerSvc, PrincipalSvc) {
    var ctrl = this;

    ctrl.searchSellersAndPrincipals = searchSellersAndPrincipals;

    /**
     * Recherche des fournisseurs ou des donneurs d'ordres avec autocomplétion.
     */
    function searchSellersAndPrincipals(value) {
      if (value && value.length >= 3) {
        var sellersPromise = KissSellerSvc.searchSellers(value).then(sellers => {
          return _.uniqBy(sellers, 'legalEntity.id');
        });
        var principalsPromise = PrincipalSvc.searchPrincipals(value);
        return $q.all([sellersPromise, principalsPromise]).then(entities => {
          return _.filter(
            _.flattenDeep(entities),
            entity => !entity.profilSellerInvited || entity.profilBuyer || entity.profilSeller
          );
        });
      }
    }
  }
})();
